export const manageListTable = [
  {
    prop: 'userNumber',
    label: '编号',
    width: 250,
    sortable: 'custom'
  },
  {
    prop: 'nickName',
    label: '昵称',
    width: 400
  },
  {
    prop: 'roleName',
    label: '用户角色',
    width: 150
  },
  {
    prop: 'edit',
    label: '编辑',
    contentCellClass: 'iconfont icon-bianji',
    width: 165
  }
];
